import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import '../styles/EULA.css';

const EndUserLicenseAgreement = () => {
  const navigate = useNavigate();
  const eula = `
End User License Agreement (EULA)
Last Updated: April 3, 2025

This End User License Agreement ("EULA") governs your use of the Sync app ("Licensed Application") and is between you and Sync, not Apple. By downloading, installing, or using the Licensed Application, you agree to be bound by this EULA. If you do not agree, do not use the Licensed Application.

1. Acknowledgement
This EULA is concluded between you and Sync only, and not with Apple. Sync, not Apple, is solely responsible for the Licensed Application and its content. You acknowledge that Sync has reviewed the Apple Media Services Terms and Conditions, and this EULA does not conflict with them.

2. Scope of License
Sync grants you a non-transferable license to use the Licensed Application on any Apple-branded products that you own or control, as permitted by the Usage Rules set forth in the Apple Media Services Terms and Conditions. The Licensed Application may also be accessed and used by other accounts associated with you via Family Sharing or volume purchasing.

3. Maintenance and Support
Sync is solely responsible for providing any maintenance and support services for the Licensed Application, as specified in this EULA or as required by applicable law. You acknowledge that Apple has no obligation whatsoever to furnish any maintenance or support services with respect to the Licensed Application.

4. Warranty
Sync is responsible for any product warranties, whether express or implied by law, to the extent not effectively disclaimed. The Licensed Application is provided "as is" without additional warranties. In the event of any failure of the Licensed Application to conform to any applicable warranty, you may notify Apple, and Apple will refund the purchase price (if any) for the Licensed Application to you. To the maximum extent permitted by applicable law, Apple will have no other warranty obligation whatsoever with respect to the Licensed Application, and any other claims, losses, liabilities, damages, costs, or expenses attributable to any failure to conform to any warranty will be Sync’s sole responsibility.

5. Product Claims
You and Sync acknowledge that Sync, not Apple, is responsible for addressing any claims by you or any third party relating to the Licensed Application or your possession and/or use of the Licensed Application, including but not limited to: (i) product liability claims; (ii) any claim that the Licensed Application fails to conform to any applicable legal or regulatory requirement; and (iii) claims arising under consumer protection, privacy, or similar legislation.

6. Intellectual Property Rights
In the event of any third-party claim that the Licensed Application or your possession and use of the Licensed Application infringes that third party’s intellectual property rights, Sync, not Apple, will be solely responsible for the investigation, defense, settlement, and discharge of any such intellectual property infringement claim.

7. Legal Compliance
You represent and warrant that (i) you are not located in a country that is subject to a U.S. Government embargo, or that has been designated by the U.S. Government as a “terrorist supporting” country; and (ii) you are not listed on any U.S. Government list of prohibited or restricted parties.

8. Developer Name and Address
For any questions, complaints, or claims with respect to the Licensed Application, please contact:
Sync
Sync Music Technologies LLC
1544 E River Rd
Grafton, WI 53024, USA
Phone: (949) 278-2418
Email: hello@syncmusic.app

9. Third Party Terms of Agreement
You must comply with applicable third-party terms of agreement when using the Licensed Application. For example, you must not violate your wireless data service agreement when using Sync.

10. Third Party Beneficiary
You and Sync acknowledge and agree that Apple, and Apple’s subsidiaries, are third-party beneficiaries of this EULA. Upon your acceptance of the terms and conditions of this EULA, Apple will have the right (and will be deemed to have accepted the right) to enforce this EULA against you as a third-party beneficiary thereof.

11. Additional Terms
This EULA applies solely to your use of the Licensed Application. Additional terms governing your broader use of Sync’s services, including account creation and content uploads, are outlined in the Sync Terms of Service, available separately.
  `;

  return (
    <div className="eula-container">
      <div className="header-container">
        <button className="back-button" onClick={() => navigate(-1)}>
          <FaArrowLeft size={24} />
        </button>
        <h1 className="header">End User License Agreement</h1>
        <div className="placeholder"></div>
      </div>
      <div className="content">
        <p className="text">{eula}</p>
      </div>
    </div>
  );
};

export default EndUserLicenseAgreement;